<template>
  <div class="department-mangement">
    <div class="relative">
      <SearchComponent
        :condition="condition"
        :routeName="$route.name"
        @updateData="_updateData"
      >
        <template #default="{pickerOptions,searchData}">
          <div class="input-box">
            <span class="name">部门名称：</span>
            <div class="input">
              <el-input
                v-model="condition.departmentName"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box datepicks">
            <span class="name">创建时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.time"
                type="date"
                unlink-panels
                placeholder="请选择"
                clearable
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">联系人：</span>
            <div class="input">
              <el-input
                v-model="condition.name"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box">
            <span class="name">电话：</span>
            <div class="input">
              <el-input
                v-model="condition.phone"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <el-button
            class="iconfont icon-sousuo"
            size="60"
            round
            @click="searchData"
          />
          <div class="operator" v-permission:add="$route.meta.permission">
            <el-button
              class="iconfont icon-tianjia sub-color"
              size="36"
              @click="editor"
              round
            />
            <span class="tips">新建部门</span>
          </div>
        </template>
      </SearchComponent>
      <TableComponent
        :tableData="tableData"
        :routeName="$route.name"
        @updateData="_updateData"
      >
        <template #btn="{handleSelectionDel}">
          <el-button
            size="98"
            class="del-color"
            @click="handleSelectionDel"
            v-permission:del="$route.meta.permission"
          >
            删除
          </el-button>
        </template>
        <template #default="{handleDelete}">
          <el-table-column type="selection" align="center" width="130" />
          <el-table-column
            prop="departmentName"
            label="部门名称"
            min-width="180"
          />
          <el-table-column prop="name" label="联系人" min-width="180" />
          <el-table-column prop="phone" label="手机号" min-width="180" />
          <el-table-column
            prop="time"
            label="创建时间"
            align="center"
            min-width="180"
          />
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            min-width="180"
          />
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            class-name="visible"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-button
                class="iconfont icon-bianji"
                size="36"
                round
                @click="editor(scope.row)"
                v-permission:editor="$route.meta.permission"
              />
              <el-button
                class="iconfont icon-shanchu"
                size="36"
                round
                @click="handleDelete(scope.$index, scope.row)"
                v-permission:del="$route.meta.permission"
              />
            </template>
          </el-table-column>
        </template>
      </TableComponent>
      <div class="mask" v-if="dialogVisible">
        <el-dialog
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :modal="false"
          custom-class="dialog"
          width="31.2rem"
          :center="true"
        >
          <el-form :model="form" label-width="auto">
            <el-form-item label="上级部门：">
              <div class="input-box">
                <div class="input">
                  <el-select
                    v-model="form.parentId"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="item in filterDownData('partList')"
                      :key="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="部门名称：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.departmentName"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="联系人：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.name"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="联系人手机：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.phone"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="备注：">
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="form.remark"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="sub-color" size="98" @click="savePart">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchCompnent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'
import filterDownData from 'mixins/filterDownData'
import { mapActions } from 'vuex'

export default {
  name: 'departmentMangement',
  components: {
    SearchComponent,
    TableComponent
  },
  mixins: [updateData, filterDownData],
  data() {
    this.keyMap = {
      part_list: {
        name: 'tableData',
        add_time: 'time',
        contacts: 'name',
        contacts_telephone: 'phone',
        part_id: 'id',
        part_name: 'departmentName',
        part_parent_id: 'parentId',
        part_remark: 'remark',
        two_department: 'children'
      }
    }
    return {
      dialogVisible: false,
      condition: {},
      tableData: [],
      form: {}
    }
  },
  created() {
    this._getPartList({
      curpage: 1
    })
  },
  methods: {
    ...mapActions(['_getAllDownData']),
    /**
     * 获取部门列表
     * @param params
     * @private
     */
    _getPartList(params) {
      this.api.getPartList(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.tableData = res.tableData
      })
    },
    /**
     * 编辑新建
     * @param item
     */
    editor(item) {
      if (item.id) {
        this.form = this.utils._cloneDeep(item)
      } else {
        this.form = {}
      }
      this.dialogVisible = true
    },
    /**
     * 保存部门
     * @private
     */
    savePart() {
      const { name, phone, id, parentId, remark, departmentName } = this.form
      const data = {
        contacts: name,
        contacts_telephone: phone,
        part_id: id,
        part_name: departmentName,
        part_parent_id: parentId,
        part_remark: remark
      }
      this.utils._checkSearchCondition(data)
      this.api.savePart(data).then(() => {
        this._getPartList()
        if (!data.part_parent_id) {
          this._getAllDownData() // 更新所有下拉值
        }
        this.$notify({
          type: 'success',
          message: '保存成功~！😝'
        })
        this.dialogVisible = false
      })
    }
  }
}
</script>
<style lang="scss">
.department-mangement {
  .input-wrapper {
    position: relative;
    width: calc(100% - 16.3rem);
    margin-right: 1.3rem;
  }

  .operator {
    position: absolute;
    top: 0;
    right: -16.3rem;
    width: 15rem;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .tips {
      margin-top: 0.3rem;
    }
  }
}
</style>
